var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuEditionNftIcon = function SvgMenuEditionNftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108551",
    d: "M20.656 4.349a1.087 1.087 0 0 1 1.087 1.087v13.046a3.261 3.261 0 0 1-3.261 3.261H5.436a1.087 1.087 0 1 1 0-2.174h13.046a1.087 1.087 0 0 0 1.087-1.087V5.436a1.087 1.087 0 0 1 1.087-1.087Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108552",
    d: "M0 3.261A3.261 3.261 0 0 1 3.261 0h10.871a3.261 3.261 0 0 1 3.261 3.261v10.871a3.261 3.261 0 0 1-3.261 3.261H3.261A3.261 3.261 0 0 1 0 14.133Zm3.261-1.087a1.087 1.087 0 0 0-1.087 1.087v10.871a1.087 1.087 0 0 0 1.087 1.087h10.871a1.087 1.087 0 0 0 1.087-1.087V3.261a1.087 1.087 0 0 0-1.087-1.087Z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108553",
    d: "M11.415 7.61a1.631 1.631 0 1 0-1.631-1.63 1.631 1.631 0 0 0 1.631 1.63Z",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108554",
    d: "M6.429 6.524a2.174 2.174 0 0 0-3.075 0L.318 9.56a1.087 1.087 0 1 0 1.537 1.537l3.036-3.036 5.21 5.21a1.087 1.087 0 0 0 1.537 0l2.118-2.118 1.99 1.194a1.087 1.087 0 1 0 1.119-1.864l-1.99-1.194a2.174 2.174 0 0 0-2.656.327l-1.349 1.349Z",
    fillRule: "evenodd"
  })));
};
export default SvgMenuEditionNftIcon;